import {
  ORDER_PUNCH_CARD_REQUEST,
  ORDER_PUNCH_CARD_SUCCESS,
  ORDER_PUNCH_CARD_FAILURE,
} from '../../actions/types';

import { createPunchCard } from './factories';

const initialState = {
  error: null,
  loading: false,
  punchCards: {},
};

export default function punchCardsReducer(state = initialState, action = {}) {
  switch (action.type) {
    case ORDER_PUNCH_CARD_REQUEST:
      return {
        ...state,
        error: null,
        loading: true,
      };
    case ORDER_PUNCH_CARD_FAILURE:
      return {
        ...state,
        loading: false,
        error: {
          statusCode: action.status,
          message: action.message,
        },
      };
    case ORDER_PUNCH_CARD_SUCCESS:
      return {
        ...state,
        loading: false,
        punchCards: {
          ...state.punchCards,
          [action.payload.orderId]: createPunchCard(action.payload),
        },
      };
    default:
      return { ...state };
  }
}
